import { DataStub, getPatchedDataSchema } from '@tencent/data-schema-core';
const emptyObjectSchema = getPatchedDataSchema({
  type: 'object'
});
export function processPropsSchema(dataSchema) {
  var _stub$definedFields;
  if (!dataSchema) {
    return {
      defaultValue: {},
      allowInteropFields: [],
      newDataSchema: emptyObjectSchema
    };
  }
  const stub = new DataStub({
    schema: dataSchema
  });
  const defaultValue = stub.getDefaultValue({
    ignoreCondition: true,
    includeOptional: true
  });
  const allowInteropFields = [];
  (_stub$definedFields = stub.definedFields) === null || _stub$definedFields === void 0 || _stub$definedFields.forEach(field => {
    var _field$ucAllowIntero;
    if (field.id && ((_field$ucAllowIntero = field['uc:allowInterop']) !== null && _field$ucAllowIntero !== void 0 ? _field$ucAllowIntero : field.type === 'string')) {
      allowInteropFields.push(field.id);
    }
  });
  const newDataSchema = {
    ...stub.schema,
    fields: stub.schema.fields.map(x => {
      const patches = {};
      if (!x['uc:allowInterop'] && allowInteropFields.includes(x.id)) patches['uc:allowInterop'] = true;
      // eslint-disable-next-line eqeqeq
      if (x['uc:allowExpr'] == null) patches['uc:allowExpr'] = true;
      // eslint-disable-next-line eqeqeq
      if (x['uc:allowReset'] == null) patches['uc:allowReset'] = true;
      if (Object.keys(patches).length) return {
        ...x,
        ...patches
      };
      return x;
    })
  };
  return {
    defaultValue,
    allowInteropFields,
    newDataSchema
  };
}